import { create } from "zustand";
import { persist } from "zustand/middleware";

// Phase 11a — Instance state mode: 'demo' (seeded data) vs 'fresh' (Day-1 empty states)
//   Toggled in TopBar user menu. Default 'fresh' so new installs don't inherit demo channel state.

export const useInstanceStateStore = create(
  persist(
    (set) => ({
      mode: "fresh",
      setMode: (mode) => set({ mode }),
      isFresh: () => false, // selector via component
    }),
    { name: "sellix.instanceState.v1" },
  ),
);
